(() => {
  const c = window.HarloConversion;
  if (!c) return;
  let ph;
  let attached = false;
  let cartSync;
  const consent = () => !c.preview && !ph?.has_opted_out_capturing?.() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== false;
  c.capture = (event, properties = {}) => {
    const client = ph || window.posthog;
    if (!client?.capture || !consent()) return;
    try { client.capture(event, { ...c.properties(), ...properties }); } catch {}
  };
  c.bridge = () => {
    try {
    if (!ph || !consent()) return null;
    const id = ph.get_distinct_id?.();
    if (typeof id !== 'string' || !id) return null;
    const previous = c.storage.get('harlo-checkout-context-v1') || {};
    const context = {
      ...c.properties(), distinct_id: id, session_id: ph.get_session_id?.() || null,
      pdp_variant: c.productPage ? c.pdpVariant : previous.pdp_variant || null,
      updated: Date.now()
    };
    c.storage.set('harlo-checkout-context-v1', context);
    document.cookie = 'harlo_checkout_v1=' + encodeURIComponent(JSON.stringify(context)) + '; Path=/; Max-Age=2592000; SameSite=Lax; Secure';
    return context;
    } catch { return null; }
  };
  c.syncCart = () => {
    const context = c.bridge();
    if (!context) return Promise.resolve();
    if (cartSync) return cartSync;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 700);
    cartSync = fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      signal: controller.signal,
      body: JSON.stringify({ attributes: { _harlo_analytics: JSON.stringify(context) } })
    }).then(response => { if (!response.ok) throw new Error('Cart attribution unavailable'); })
      .catch(() => c.capture('checkout_attribution_unavailable'))
      .finally(() => { clearTimeout(timer); cartSync = null; });
    return cartSync;
  };
  c.beforeCheckout = async (source) => {
    try {
      c.capture('checkout_clicked', { checkout_source: source });
      await c.syncCart();
      c.capture('checkout_redirected', { checkout_source: source });
    } catch {}
  };
  c.attach = instance => {
    if (!instance?.__loaded) return;
    ph = instance;
    ph.register(c.properties());
    c.bridge();
    if (attached) return;
    attached = true;
    ph.onSessionId?.(() => c.bridge());
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') c.bridge(); });
    document.addEventListener('visitorConsentCollected', () => c.bridge());
  };
  c.attach(window.posthog);
  window.addEventListener('harlo:posthog-ready', () => c.attach(window.posthog));
  const pickerState = picker => ({
    purchase_type: picker?.selectedSellingPlan ? 'subscription' : 'one_time',
    selling_plan_id: picker?.selectedSellingPlan?.id || null,
    product_id: picker?.product?.id || null,
    pdp_variant: c.pdpVariant
  });
  document.addEventListener('harlo:offer-ready', event => {
    const picker = event.target;
    c.capture('harlo_offer_viewed', pickerState(picker));
    c.bridge();
  });
  document.addEventListener('skio::update-selling-plan', event => {
    const picker = event.target.closest?.('skio-plan-picker');
    if (!picker || !picker.dataset.harloOfferReady) return;
    c.capture('purchase_option_changed', pickerState(picker));
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('product-form form')) return;
    const picker = document.querySelector('skio-plan-picker');
    c.capture('purchase_submitted', pickerState(picker));
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-harlo-listicle-cta]');
    if (link) c.capture('listicle_cta_clicked', { listicle_path: location.pathname, cta_position: link.closest('.ha-sticky') ? 'sticky' : link.closest('.ha-hero') ? 'hero' : 'body' });
  });
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      c.capture('purchase_controls_seen', { pdp_variant: c.pdpVariant });
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.5 });
  for (const el of document.querySelectorAll('product-form .product-form__submit')) observer.observe(el);
})();
